import { Field } from "react-final-form";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";

interface TimePickerProps {
  name: string;
  label?: string;
  helperText?: string;
  required?: boolean;
  format?: string;

  ampm?: boolean;
  views?: ("hours" | "minutes" | "seconds")[];
  minutesStep?: number;
  outputFormat?: "moment" | "date-string" | "time-string" | "iso" | string;
  [key: string]: any;
}

export function TimePicker(props: TimePickerProps) {
  const {
    format = "HH:mm",
    ampm = false,
    views = ["hours", "minutes"],
    minutesStep,
    outputFormat = "HH:mm",
    ...fieldProps
  } = props;

  return (
    <Field
      {...fieldProps}
      render={({
        input: { onChange, value },
        label,
        helperText,
        required,
      }: any) => {
        // Создаем значение времени для MUI TimePicker
        const getTimeValue = () => {
          if (!value) return null;

          // Парсим время с учетом возможных форматов
          if (
            typeof value === "string" &&
            /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)
          ) {
            // Если это строка в формате HH:MM, парсим с указанным форматом и используем сегодняшнюю дату
            const timeMoment = moment(value, "HH:mm");
            return moment()
              .hours(timeMoment.hours())
              .minutes(timeMoment.minutes())
              .seconds(0);
          } else {
            // Иначе используем стандартный парсинг
            return moment(value);
          }
        };

        const handleChange = (newValue: any) => {
          if (!newValue) {
            onChange(null);
            return;
          }

          // Извлекаем только время из выбранного значения
          const timeMoment = moment(newValue);

          // Форматируем согласно outputFormat
          let outputValue: any;
          switch (outputFormat) {
            case "date-string":
              outputValue = timeMoment.format("YYYY-MM-DD");
              break;
            case "time-string":
              outputValue = timeMoment.format("HH:mm:ss");
              break;
            case "iso":
              outputValue = timeMoment.toISOString();
              break;
            case "moment":
              outputValue = timeMoment.toDate();
              break;
            default:
              // Кастомный формат (по умолчанию HH:mm)
              outputValue = timeMoment.format(outputFormat);
          }

          onChange(outputValue);
        };

        return (
          <MuiTimePicker
            label={label}
            ampm={ampm}
            views={views}
            minutesStep={minutesStep}
            value={getTimeValue()}
            onChange={handleChange}
            format={format}
            slots={{
              openPickerButton: (props: any) => {
                return (
                  <InputAdornment position="end">
                    {value && (
                      <IconButton
                        size="small"
                        onClick={() => onChange(null)}
                        aria-label="clear"
                        style={{ marginRight: "-4px" }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                    <IconButton
                      {...props}
                      size="small"
                      color="primary"
                      aria-label="open picker"
                    >
                      {props.children}
                    </IconButton>
                  </InputAdornment>
                );
              },
            }}
            slotProps={{
              textField: {
                fullWidth: true,
                required,
                helperText,
              },
            }}
          />
        );
      }}
    />
  );
}
